module.exports = __webpack_public_path__ + "static/media/chemical-energy.aa7c393d.svg";